import { createBrowserRouter } from "react-router-dom";
import Home from "./pages/Home";

import Syster from "./pages/Syster";
import Cloud from "./pages/Cloud";
import AddValue from "./pages/AddValue";
import AiModel from "./pages/AiModel";
import About from "./pages/About";
import Zhishi from "./pages/Zhishi";
import Rongyu from "./pages/Rongyu";
import News from "./pages/News";
import New from "./pages/New";
import Newa from "./pages/New/index1";
import Newb from "./pages/New/index2";
import Newc from "./pages/New/index3";
import Newd from "./pages/New/index4";
import Huoban from "./pages/Huoban";
import AddUs from "./pages/JoinUs";
import Contact from "./pages/Contact";

// 创建路由实例
const router = createBrowserRouter([
  { path: "/", element: <Home />  },
  { path: "/syster", element: <Syster />,  },
  { path: "/cloud", element: <Cloud />,  },
  { path: "/addvalue", element: <AddValue />,  },
  { path: "/aimodel", element: <AiModel />,  },
  { path: "/about", element: <About />,  },
  { path: "/zhishi", element: <Zhishi />,  },
  { path: "/rongyu", element: <Rongyu />,  },
  { path: "/news", element: <News />,  },
  { path: "/new", element: <New />,  },
  { path: "/newa", element: <Newa />,  },
  { path: "/newb", element: <Newb />,  },
  { path: "/newc", element: <Newc/>,  },
  { path: "/newd", element: <Newd />,  },
  { path: "/huoban", element: <Huoban />,  },
  { path: "/joinus", element: <AddUs />,  },
  { path: "/contact", element: <Contact />,  },
]);

export default router;